module.exports = __webpack_public_path__ + "img/20200611_205903.f8f39746.jpg";